module.exports = __webpack_public_path__ + "media/img/uploads/event-thumb-05-411ce43092ff3c8d452870fdef788020.jpg";